import React from 'react';
import SubPage from '../components/SubPage';
import { subPages } from '../subpages';

export default function ServicesPage() {
  return <SubPage data={subPages.services} />;
}
